import React from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { InsuranceDTO, OwnerTypeDTO } from '../../../api/useInsuranceQuery';
import { selectCurrentClient } from '../../../../../CommonSelectors/CommonAreaSelector';

interface Props {
  data: InsuranceDTO;
}

export const PremiumEndYear = ({ data }: Props) => {
  const formBag = useFormContext<FormFields>();

  const ownerModel = formBag.watch('OwnerModel');

  const { Dob: primaryDob, PartnerDob: spouseDob } = useSelector(selectCurrentClient);

  const primaryYob = primaryDob ? new Date(primaryDob).getFullYear() : null;
  const spouseYob = spouseDob ? new Date(spouseDob).getFullYear() : null;

  const selectedOwnerType =
    ownerModel.length === 1 &&
    data.Options.InsuranceOwnerOptions.People.find(val => val.Name === ownerModel[0].Name)
      ?.OwnerType;

  const isPrimary = selectedOwnerType === OwnerTypeDTO.Principal;
  const isSpouse = selectedOwnerType === OwnerTypeDTO.Spouse;

  const options = data.Options.InsurancePremiumEndYearOptions.map((year, index) => {
    const yearNumber = Number(year);

    let rightLabel: string | undefined;

    if (Number.isInteger(yearNumber)) {
      if (isPrimary && primaryYob) {
        rightLabel = `Age ${yearNumber - primaryYob}`;
      } else if (isSpouse && spouseYob) {
        rightLabel = `Age ${yearNumber - spouseYob}`;
      }
    }

    return {
      label: year,
      value: index === 0 ? null : year,
      rightLabel,
    };
  });

  return (
    <Controller
      control={formBag.control}
      name="InsurancePremiumEndYear"
      render={({ field: { value, onChange, disabled } }) => {
        // We still want to show previously selected years
        // even if they are no longer part of the options
        const selectedValue =
          value === null
            ? { value, label: data.Options.InsurancePremiumEndYearOptions[0] }
            : { value, label: value };

        return (
          <Select
            label="Premium End Year"
            value={selectedValue}
            options={options}
            onChange={opt => onChange(opt?.value)}
            disabled={disabled}
            isPortal
          />
        );
      }}
    />
  );
};
